import React, {useState, useEffect} from 'react';
import axios from 'axios';
import "./weatherapp.css";
import search_icon from "../components/Assets/search.png";
import clear_icon from "../components/Assets/clear.png";
import humidity_icon from "../components/Assets/humidity.png";
import wind_icon from "../components/Assets/wind.png";




export const WeatherApp = () => {

  const api_key = "e5604f1af448e04858452ef3c3e9d46b"; // Replace with your OpenWeatherMap API key

  const [city, setCity] = useState(''); // Initialize city state with an empty string
  const [weatherIcon, setWeatherIcon] = useState('');


  function getCity(event) {
    setCity(event.target.value);
  }

  const getWeather = async () => {
    if (city) {
      const url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&units=Metric&appid=${api_key}`;
      try {
        const response = await axios.get(url);
        setWeather(response.data); 
        const iconCode = response.data.weather[0].icon;
        setWeatherIcon(`https://openweathermap.org/img/wn/${iconCode}@2x.png`);
      } catch (error) {
        console.error(error);
      }
    }
  };

  // Move the URL construction inside the useEffect to ensure it reflects the latest value of 'city'
  const [weather, setWeather] = useState({}); // Initialize weather state with an object

  useEffect(() => {
    if (city) {
      const url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&units=Metric&appid=${api_key}`;
      axios.get(url)
        .then(response => {
          setWeather(response.data);
        })
        .catch(error => {
          console.error(error);
        });
    }
    getWeather();
  }, [city]);

  const changeBg = () => {
    if (weather.main && weather.main.temp < 1) {
      return ('container-snow')
    } else {
      return ('container')
    }
  }


  return (
    <>
    <div className={changeBg(weather.main && weather.main.temp)}>
      <div className="top-bar">
        <input type="text" className="cityInput" placeholder='City-Search' onChange={getCity}/>
        <div className="search-icon" onClick={getWeather}>
          <img src= {search_icon} alt='search sign'></img>
        </div>
      </div>
      <div className="weather-image">
        <img src={weatherIcon? weatherIcon : clear_icon} alt='cloud icon' ></img>
      </div>
      <div className="weather-temp" >
      {weather.main && weather.main.temp? weather.main && weather.main.temp : 0} °C
      </div>
      <div className="weather-location">
      {weather.name? weather.name : "City"}
      </div>
      <div className="data-container">
        <div className="element">
          <img src={humidity_icon} alt="humidity icon" className="icon" />
          <div className="data">
            <div className="humidity-percent">{weather.main && weather.main.humidity? weather.main && weather.main.humidity: 0}%</div>
            <div className="text">Humidity</div>
          </div>
        </div>
        <div className="element">
          <img src={wind_icon} alt="wind speed icon" className="icon" />
          <div className="data">
            <div className="wind-rate">{weather.wind && weather.wind.speed? weather.wind && weather.wind.speed: 0} km/h</div>
            <div className="text">Wind Speed</div>
          </div>
        </div>
      </div>
    
    </div>
    </>
  )
}

